<template>
  <v-container grid-list-md class="mt-3 pa-0">
    <div v-if="isLoading" class="mt-5">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div>

    <div v-if="!isLoading && listUserPlant.length === 0">
      <v-layout row wrap flex justify-center align-center>
        <span class="title font-weight-bold">
          ยังไม่มีบันทึกการปลูกต้นไม้ของผู้ใช้นี้
        </span>
      </v-layout>
      <v-layout row wrap justify-center class="mt-3">
        <v-flex xs12 sm6 md3>
          <div class="ta-c">
            <v-btn
              color="primary"
              round
              block
              class="mx-0"
              @click="addTree"
            >
              เพิ่มการปลูกต้นไม้
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-container
      v-if="!isLoading && listUserPlant.length !== 0"
      class="mt-0 pa-0"
    >
      <v-layout row wrap justify-space-between align-center mb-2>
        <div>
          <span class="headline font-weight-bold">ต้นไม้ของผู้ใช้</span>
        </div>
        <div class="ta-c">
          <v-btn color="primary" round class="mx-0" @click="addTree">
            เพิ่มการปลูกต้นไม้
          </v-btn>
        </div>
      </v-layout>

      <v-card flat>
        <v-card-text>
          <v-layout v-resize="onResize" column>
            <v-data-table
              :headers="headers"
              :items="listUserPlant"
              item-key="user_plant_id"
              hide-actions
              :loading="loading"
              :pagination.sync="pagination"
              ref="dTable"
              :hide-headers="isMobile"
              :class="{ mobile: isMobile }"
            >
              <template v-slot:items="props">
                <tr
                  v-if="!isMobile"
                  :class="{ 'unpublished-row': isUnpublished(props.item) }"
                >
                  <td class="text-xs-left">
                    {{ props.index + 1 }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.date_planting) }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.plant_name }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.amount }}
                  </td>
                  <td class="text-xs-left">
                    <span v-if="props.item.province_name !== 'กรุงเทพมหานคร'">
                      ตำบล{{ props.item.tambon_name }}
                      อำเภอ{{ props.item.amphoe_name }}
                      จังหวัด{{ props.item.province_name }}
                    </span>
                    <span v-else>
                      แขวง{{ props.item.tambon_name }}
                      เขต{{ props.item.amphoe_name }}
                      จังหวัด{{ props.item.province_name }}
                    </span>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.department_name }}
                    <span
                      v-if="props.item.department_id == 1"
                      style="font-size: 14px"
                    >
                      - {{ props.item.sub_department_name_level1 }} -
                      {{ props.item.sub_department_name_level2 }}
                    </span>
                    <span
                      v-if="
                        props.item.other !== '' &&
                        props.item.department_id == 4
                      "
                    >
                      - {{ props.item.other }}
                    </span>
                  </td>
                  <td class="text-xs-left">
                    <span v-if="props.item.note !== ''">
                      {{ props.item.note }}
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-xs-right" style="white-space: nowrap">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon dark v-on="on">
                          <v-icon
                            @click.stop.prevent="
                              editTree(
                                props.item.date_planting,
                                props.item.plant_id,
                                props.item.user_plant_id,
                                props.item.amount,
                                props.item.latitude,
                                props.item.longitude,
                                props.item.province_id,
                                props.item.province_name,
                                props.item.amphoe_id,
                                props.item.amphoe_name,
                                props.item.tambon_id,
                                props.item.tambon_name,
                                props.item.department_id,
                                props.item.sub_department_id_level1,
                                props.item.sub_department_id_level2,
                                props.item.sub_department_name_level2,
                                props.item.parent_department_id,
                                props.item.other,
                                props.item.note
                              )
                            "
                            color="blue-grey"
                          >
                            edit
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูลต้นไม้</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon dark v-on="on">
                          <v-icon
                            @click.stop.prevent="toggleUnpublished(props.item)"
                            :color="isUnpublished(props.item) ? 'orange' : 'grey'"
                          >
                            {{ isUnpublished(props.item) ? 'visibility' : 'visibility_off' }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{
                          isUnpublished(props.item)
                            ? 'เผยแพร่การปลูกครั้งนี้'
                            : 'ระงับการเผยแพร่การปลูกครั้งนี้'
                        }}
                      </span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon dark v-on="on">
                          <v-icon
                            @click.stop.prevent="
                              deleteItem(props.item.user_plant_id)
                            "
                            color="red"
                          >
                            delete
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูลต้นไม้</span>
                    </v-tooltip>
                  </td>
                </tr>

                <!-- mobile -->
                <tr
                  @click="props.expanded = !props.expanded"
                  v-else
                >
                  <td>
                    <ul
                      class="flex-content"
                      :class="{ 'unpublished-row': isUnpublished(props.item) }"
                    >
                      <li class="flex-item" data-label="ครั้งที่">
                        {{ props.index + 1 }}
                      </li>
                      <li class="flex-item" data-label="ปลูกวันที่">
                        {{ formatDate(props.item.date_planting) }}
                      </li>
                      <li class="flex-item" data-label="ชนิดไม้">
                        {{ props.item.plant_name }}
                      </li>
                      <li class="flex-item" data-label="จำนวน">
                        {{ props.item.amount }} ต้น
                      </li>
                      <li
                        class="flex-item"
                        data-label="ปลูกที่"
                        v-if="props.item.province_name !== 'กรุงเทพมหานคร'"
                      >
                        ตำบล{{ props.item.tambon_name }}
                        อำเภอ{{ props.item.amphoe_name }}
                        จังหวัด{{ props.item.province_name }}
                      </li>
                      <li
                        class="flex-item"
                        data-label="ปลูกที่"
                        v-else
                      >
                        แขวง{{ props.item.tambon_name }}
                        เขต{{ props.item.amphoe_name }}
                        จังหวัด{{ props.item.province_name }}
                      </li>
                      <li class="flex-item" data-label="ได้รับต้นไม้จาก">
                        {{ props.item.department_name }}
                        <span
                          v-if="props.item.department_id == 1"
                          style="font-size: 14px"
                        >
                          - {{ props.item.sub_department_name_level1 }} -
                          {{ props.item.sub_department_name_level2 }}
                        </span>
                        <span
                          v-if="props.item.other !== ''"
                        >
                          - {{ props.item.other }}
                        </span>
                      </li>
                      <li
                        class="flex-item"
                        data-label="บันทึกเพิ่มเติม"
                      >
                        <span v-if="props.item.note !== ''">
                          {{ props.item.note }}
                        </span>
                        <span v-else>-</span>
                      </li>
                      <span
                        class="flex-item"
                        style="display:flex;padding-right:0 !important"
                      >
                        <div
                          style="width:100%;justify-content:flex-end;text-align:right"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon dark v-on="on">
                                <v-icon
                                  @click.stop.prevent="
                                    editTree(
                                      props.item.date_planting,
                                      props.item.plant_id,
                                      props.item.user_plant_id,
                                      props.item.amount,
                                      props.item.latitude,
                                      props.item.longitude,
                                      props.item.province_id,
                                      props.item.province_name,
                                      props.item.amphoe_id,
                                      props.item.amphoe_name,
                                      props.item.tambon_id,
                                      props.item.tambon_name,
                                      props.item.department_id,
                                      props.item.sub_department_id_level1,
                                      props.item.sub_department_id_level2,
                                      props.item.sub_department_name_level2,
                                      props.item.parent_department_id,
                                      props.item.other,
                                      props.item.note
                                    )
                                  "
                                  color="blue-grey"
                                >
                                  edit
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>แก้ไขข้อมูลต้นไม้</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon dark v-on="on">
                                <v-icon
                                  @click.stop.prevent="
                                    toggleUnpublished(props.item)
                                  "
                                  :color="
                                    isUnpublished(props.item) ? 'orange' : 'grey'
                                  "
                                >
                                  {{
                                    isUnpublished(props.item)
                                      ? 'visibility'
                                      : 'visibility_off'
                                  }}
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>
                              {{
                                isUnpublished(props.item)
                                  ? 'เผยแพร่การปลูกครั้งนี้'
                                  : 'ระงับการเผยแพร่การปลูกครั้งนี้'
                              }}
                            </span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon dark v-on="on">
                                <v-icon
                                  @click.stop.prevent="
                                    deleteItem(props.item.user_plant_id)
                                  "
                                  color="red"
                                >
                                  delete
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>ลบข้อมูลต้นไม้</span>
                          </v-tooltip>
                        </div>
                      </span>
                    </ul>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>

    <ModalAddTree
      ref="ModalAddTree"
      @fetch="queryListUserPlant"
      :card-id="cardId"
    />
    <ModalEditTree
      ref="ModalEditTree"
      @fetch="queryListUserPlant"
      :card-id="cardId"
    />
  </v-container>
</template>

<script>
import ModalAddTree from "@/components/ModalAddTree";
import ModalEditTree from "@/components/ModalEditTree";

export default {
  components: {
    ModalAddTree,
    ModalEditTree
  },
  props: {
    cardId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isMobile: false,
      loading: true,
      isLoading: true,
      listUserPlant: [],
      pagination: {
        sortBy: "date_planting",
        rowsPerPage: -1
      },
      headers: [
        {
          text: "ครั้งที่",
          align: "left",
          sortable: true,
          value: "plant_time",
          width: "1",
          class: "font-weight-bold"
        },
        {
          text: "ปลูกวันที่",
          align: "left",
          sortable: false,
          value: "date_planting",
          width: "3",
          class: "font-weight-bold"
        },
        {
          text: "ชนิดไม้",
          align: "left",
          sortable: false,
          value: "plant_name",
          width: "3",
          class: "font-weight-bold"
        },
        {
          text: "จำนวน (ต้น)",
          align: "left",
          sortable: false,
          value: "amount",
          width: "1",
          class: "font-weight-bold"
        },
        {
          text: "สถานที่ปลูก",
          align: "left",
          sortable: false,
          value: "tambon_name",
          width: "3",
          class: "font-weight-bold"
        },
        {
          text: "ได้รับต้นไม้จาก",
          align: "left",
          sortable: false,
          value: "department_name",
          width: "2",
          class: "font-weight-bold"
        },
        {
          text: "บันทึกเพิ่มเติม",
          align: "left",
          sortable: false,
          value: "note",
          width: "2",
          class: "font-weight-bold"
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "",
          width: "10",
          class: "font-weight-bold"
        }
      ]
    };
  },
  created() {
    this.isLoading = true;
    this.queryListUserPlant();
  },
  methods: {
    isUnpublished(item) {
      if (!item) return false;
      const val = item.unpublished;
      return val === 1 || val === '1' || val === true;
    },
    addTree() {
      this.$refs.ModalAddTree.openDialog();
    },
    editTree(
      date_planting,
      plant_id,
      user_plant_id,
      amount,
      latitude,
      longitude,
      province_id,
      province_name,
      amphoe_id,
      amphoe_name,
      tambon_id,
      tambon_name,
      department_id,
      sub_department_id_level1,
      sub_department_id_level2,
      sub_department_name_level2,
      parent_department_id,
      other,
      note
    ) {
      this.$refs.ModalEditTree.openDialog(
        date_planting,
        plant_id,
        user_plant_id,
        amount,
        latitude,
        longitude,
        province_id,
        province_name,
        amphoe_id,
        amphoe_name,
        tambon_id,
        tambon_name,
        department_id,
        sub_department_id_level2,
        sub_department_name_level2,
        parent_department_id,
        other,
        note
      );
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      const year_thai = parseInt(year, 10) + 543;
      return `${day}-${month}-${year_thai}`;
    },
    queryListUserPlant() {
      this.isLoading = true;
      this.axios
        .post(
          process.env.VUE_APP_IPFLASK + "/queryListUserPlant",
          { card_id: this.cardId },
          { withCredentials: true }
        ).then(response => {
          if (response.data === "No data") {
            this.listUserPlant = [];
          } else {
            this.listUserPlant = response.data;
            this.loading = false;
          }
          this.isLoading = false;
        });
    },
    toggleUnpublished(item) {
      if (!item || !item.user_plant_id) {
        return;
      }

      const currentlyUnpublished = this.isUnpublished(item);
      const newValue = currentlyUnpublished ? 0 : 1;
      const actionLabel = currentlyUnpublished
        ? "เผยแพร่"
        : "ระงับการเผยแพร่";

      this.$swal({
        title: `ยืนยันการ${actionLabel}การปลูกครั้งนี้`,
        text: currentlyUnpublished
          ? "การกระทำนี้จะทำให้การปลูกครั้งนี้ถูกนับรวมในหน้าสถิติ"
          : "การกระทำนี้จะทำให้การปลูกครั้งนี้ไม่ถูกนับรวมในหน้าสถิติ แต่ผู้ปลูกจะยังคงเห็นต้นไม้ของตนเอง",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: actionLabel,
        cancelButtonText: "ยกเลิก",
        reverseButtons: true
      }).then(result => {
        if (!result.value) {
          return;
        }

        this.axios
          .post(
            process.env.VUE_APP_IPFLASK + "/adminSetUserPlantUnpublished",
            {
              user_plant_id: item.user_plant_id,
              unpublished: newValue
            },
            { withCredentials: true }
          )
          .then(response => {
            const data = response.data || {};
            const updated = typeof data.unpublished !== "undefined"
              ? data.unpublished
              : newValue;
            this.$set(item, "unpublished", updated);

            const msg = currentlyUnpublished
              ? "เผยแพร่การปลูกครั้งนี้เรียบร้อยแล้ว"
              : "ระงับการเผยแพร่การปลูกครั้งนี้เรียบร้อยแล้ว";
            this.$swal("สำเร็จ", msg, "success");
          })
          .catch(error => {
            console.error("Error setting unpublished:", error);
            this.$swal(
              "ข้อผิดพลาด",
              "ไม่สามารถเปลี่ยนสถานะการเผยแพร่ได้",
              "error"
            );
          });
      });
    },
    deleteItem(user_plant_id) {
      this.$swal({
        title: "คุณต้องการลบการปลูกต้นไม้ครั้งนี้ใช่หรือไม่",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.axios
            .post(process.env.VUE_APP_IPFLASK + "/deleteUserPlantID", {
              user_plant_id: user_plant_id
            })
            .then(response => {
              if (response.data === "Delete User Plant ID Success") {
                this.$swal("ลบการปลูกต้นไม้เรียบร้อย", "", "success");
                this.queryListUserPlant();
              }
            });
        }
      });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  }
};
</script>

<style scoped>
.flex-content {
  list-style-type: none;
  padding: 0;
}

.flex-item {
  padding: 4px 0;
}

.unpublished-row td,
.unpublished-row li {
  color: #b0bec5;
}
</style>
